import React, { useState, useEffect, useMemo } from "react";
import Typography from "../../../../../core/Typography";
import { useDevice } from "../../../../customHooks";
import Tooltip from "../../../../../core/Tooltip";
import Button from "../../../../../core/Button";
import iicon from '../../../../../assets/images/i-icon.png';
import style from "../../../../style.module.css";
import Input from "../../../../../core/Inputs/DefaultInput";
import 'react-edit-text/dist/index.css';
import Svg from "../../../../../component/common/Svg";
import DataTable from "react-data-table-component";
import Card from "../../../../../core/Card";
import Callout from '../../../../../core/Callout';
import Switch from "../../../../../core/Switch";
import { Icon } from '@blueprintjs/core';
import VariableSidebar from "../../../../../component/common/layout/VariableSidebar";
import SubHeader from "../../../../../component/common/layout/SubHeader";
import SurveyListSidebar from "../../../../../component/common/layout/SurveyListSidebar";
import SurveyListHeader from "../../../../../component/common/layout/SurveyListHeader";
import { useDispatch, useSelector } from "react-redux";
import { addCustomVariable, deleteCustomVariable, getCustomVariable, updateCustomVariable, updateCustomVariableRequirement } from "../../../../../store/actions/variableAction";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useVerifySurveyId } from "../../../../../hooks";
import { Link } from "react-router-dom";
import NestedMenuToggle from "../../../settings/NestedMenuToggle";
import { useTranslation } from 'react-i18next';

export default function CustomVariable(props) {
  //==> States <==

  //Props
  const { view } = props;

  const { t, i18n } = useTranslation();

  //Modal
  const [popupTitle, setPopupTitle] = useState(t('survey.customVariable.add'));
  const [btnTitle, setBtnTitle] = useState(t('survey.customVariable.add'));
  const [rowId, setRowId] = useState('');
  const [editMode, setEditMode] = useState(0);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [isHovering, setIsHovering] = useState(false);
  const [uniqueNameError, setUniqueNameError] = useState(null);
  const [currentlyDeleting, setCurrentlyDeleting] = useState(null);
  const [currentlyDeletingVarName, setCurrentlyDeletingVarName] = useState(null);

  //Selector
  const data = useSelector((state) => state.variables?.customVariableData)
  const customVariableLoading = useSelector((state) => state.variables?.getCustomVariableLoading)
  const { survey_name } = useSelector((state) => state.permissionsData)

  //Others
  let device = useDevice();
  const dispatch = useDispatch()
  const survey_id = useVerifySurveyId()

  const canMutate =
    editMode === 1
      ? window.modulePermissions.M15.edit == 1
      : window.modulePermissions.M15.add == 1;

  const suTypes = [
    t('survey.customVariable.number'),
    t('survey.customVariable.single'),
    t('survey.customVariable.multi'),
  ]
  const [isOpen, setOpen] = useState(false);
  const language_code = '22';


  //Columns
  const columns = useMemo(
    () => [
      {
        name: t('survey.customVariable.label'),
        cell: (row) => {
          return <span title={JSON.parse(row.su_label ?? {}) && JSON.parse(row.su_label ?? {})[language_code]}>{JSON.parse(row.su_label ?? {}) && JSON.parse(row.su_label ?? {})[language_code]}</span>
        },
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = JSON.parse(a.su_label ?? {}) && JSON.parse(a.su_label ?? {})[language_code]
          let b1 = JSON.parse(b.su_label ?? {}) && JSON.parse(b.su_label ?? {})[language_code]
          return sortString(a1, b1)
        }
      },
      {
        name:t('survey.customVariable.type'),
        selector: row => row.su_type,
        cell: (row) => {
          return <span>{row.su_type ? suTypes[Number(row.su_type) - 1] : ''}</span>
        },
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = a.su_type ? suTypes[Number(a.su_type) - 1] : ''
          let b1 = b.su_type ? suTypes[Number(b.su_type) - 1] : ''
          return sortString(a1, b1)
        }
      },
      {
        name: t('survey.customVariable.varName'),
        cell: (row) => {
          return <span title={row.su_name}>{row.su_name}</span>
        },
        sortable: true,
        sortFunction: (a, b) => {
          let a1 = a.su_name ?? ''
          let b1 = b.su_name ?? ''
          return sortString(a1, b1)
        }
      },
      // {
      //   name: "Is required",
      //   cell: (row) => {
      //     return <>
      //       <div className="action-wrapper d-flex  accordianSwitch ms-3">
      //         < Switch
      //           type='dense'
      //           color='default'
      //           label={''}
      //           disabled={false}
      //           fill={false}
      //           rtl={false}
      //           leftPosition={false}
      //           className='SwitchCustom'
      //           checked={row.su_is_required === 1}
      //           value={row.su_custom_variable_id}
      //           onChange={handleRequiredChange}
      //         />
      //       </div>
      //     </>
      //   }
      // },
      // {
      //   name: "Date added",
      //   cell: row => <>
      //     <div className="addeddate">
      //       {row.su_add_date_time}
      //     </div>
      //   </>

      // },
      {
        name: t('survey.customVariable.action'),
        cell: (row, index) => <>
          <div className="d-flex action-buttons">
            {window.modulePermissions.M15.edit == 1 && (<button title="Edit" className="action-btn" type="button" srno="1" value="1" onClick={() => { modelEdit(row) }}
              aria-haspopup="true" aria-expanded="false">
              <Svg name="table-edit" />
            </button>)}
            {window.modulePermissions.M15.del == 1 && (
            <button title="Delete" className="action-btn" type="button" data-bs-toggle="modal" data-bs-target="#deleteModal" onClick={() => { setCurrentlyDeleting(row.su_custom_variable_id); setCurrentlyDeletingVarName(row.su_name) }}>
              <Svg name="table-delete" />
            </button>
            )}
          </div>
        </>
      }
    ]
  )

  //==> FORM SCHEMA AND VALIDATION <==

  //Yup
  const formSchema = Yup.object().shape({
    label: Yup.string().trim().max(250, 'Label should be less than 250 char').required(t('survey.lRequired')),
    type: Yup.string().required('Type required'),
    varName: Yup.string().trim().test(
      "Whitespace check",
      `No white space allowed`,
      async (value) => {
        return value.indexOf(' ') === -1
      }
    ).max(50, 'Name should be less than 50 char.').required(t('survey.NRequired')),
    description: Yup.string().trim().required('Description required'),
  })

  //Formik
  const initialValues = {
    label: '',
    type: '',
    varName: '',
    description: '',
  }

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: formSchema,
    onSubmit: (data) => {
      if (editMode === 0) {
        submitCreateVariable()
      }
      else {
        submitEditVariable()
      }
    }
  })

  const { values, handleChange, handleBlur, touched, errors, resetForm, setValues, setFieldValue, setFieldTouched, handleSubmit } = formik


  //==> FUNCTIONALITIES <==

  //Form submit
  const submitCreateVariable = () => {
    const afterCreate = () => {
      fetchCustomVariable()
      cancelEditVariable()
    }
    const payload = {
      survey_id: survey_id,
      language_code: language_code,
      label_val: values.label,
      su_name: values.varName,
      su_description: values.description,
      su_type: values.type,
    }
    dispatch(addCustomVariable(payload, afterCreate, varNotAvailable))
  }

  const submitEditVariable = () => {
    const afterEdit = () => {
      fetchCustomVariable()
      cancelEditVariable()
    }
    const payload = {
      language_code: language_code,
      survey_variable_id: rowId,
      su_type: values.type,
      label_val: values.label,
      su_name: values.varName,
      su_description: values.description,
    }
    dispatch(updateCustomVariable(payload, afterEdit))
  }

  //Data handling
  const fetchCustomVariable = async () => {
    dispatch(getCustomVariable(survey_id))
  }

  const cancelEditVariable = () => {
    setIsVisibleModal(false)
    setEditMode(0);
    setPopupTitle(t('survey.customVariable.add'))
    setBtnTitle(t('survey.customVariable.add'))
    setUniqueNameError(null)
    resetForm()
  }

  const modelEdit = (row) => {
    setValues({
      label: JSON.parse(row.su_label)[language_code],
      type: row.su_type,
      varName: row.su_name,
      description: JSON.parse(row.su_description)[language_code],
    })
    setEditMode(1);
    setPopupTitle(t('survey.customVariable.edit_Variable'))
    setBtnTitle(t('survey.customVariable.update'))
    setRowId(row.su_custom_variable_id)
    setIsVisibleModal(true)
  }

  const handleChangeType = (value) => {
    setFieldValue('type', value)
  }

  function deleteVariable(id) {
    dispatch(deleteCustomVariable(id))
  }

  function handleRequiredChange(e) {
    const payload = {
      is_req: (e.target.checked) ? 1 : 0,
      survey_variable_id: e.target.value,
    }
    dispatch(updateCustomVariableRequirement(payload))
  }

  const varNotAvailable = () => {
    setUniqueNameError('Variable with this name is already in list please enter unique name')
  }

  //Tooltip
  const handleMouseOver = () => {
    setIsHovering(true);
  }

  const handleMouseOut = () => {
    setIsHovering(false);
  }

  //Sorting
  const sortString = (a, b) => {
    a = a.toLowerCase()
    b = b.toLowerCase()

    if (a > b) {
      return 1;
    }
    if (b > a) {
      return -1;
    }
    return 0;
  }

  //==> EFFECTS <==
  useEffect(() => {
    if (survey_id) {
      fetchCustomVariable();
    }
  }, [survey_id]);

  return (
    <div className='d-flex flex-column main-outer-wrapper main-site-wrapper language-page bg-white'>
      <SurveyListHeader />
      <div className="flex-grow-1 d-flex survey-main-wrapper">
        <SurveyListSidebar />

        <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column">
          <SubHeader />
          <div className="d-flex variable-pg-wrapper flex-grow-1">
            <VariableSidebar />
            <div className="flex-grow-1 variable-pg-content">
              <div className="survey-main-container">
                <div className="page-content-wrap variables-main-container p-0">
                  <div className="main-sec-wrap">
                    <div className='pagesRow varPg'>
                      <div className="page-heading">
                        {/* breadcrumbs here */}
                        <nav aria-label="breadcrumb">
                          <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/admin/survey/list">{t('survey.title')}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link></li>
                            <li className="breadcrumb-item"><Link to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>{t('survey.variable.heading')}</Link></li>
                            <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.customVariable.customVariables')}</strong></li>
                          </ol>
                        </nav>
                        {/* breadcrumbs ends here */}
                        <div className="d-flex align-items-start">
                          <div className="mt-2">
                            <NestedMenuToggle />
                          </div>
                          <div className="flex-grow-1 ps-3 ps-lg-0">
                            <h1 className="mb-0 mb-lg-3"> {t('survey.customVariable.customVariables')} <Tooltip
                              view={view}
                              color='primary'
                              content="Lead-gen variables"
                              position='top'
                              isOpen={isOpen ? isOpen : null}
                              className='black-tooltip  '
                            >
                              <Button view="outlined" className="action-btn copy ms-2 color-dark" color="primary" text=""><Svg name="copyright" /></Button>
                            </Tooltip></h1>
                            <p>
                            {t('survey.customVariable.text1')},</p>

                          </div>
                        </div>
                      </div>
                      <div className="varTable mt-5">
                        <div className="custom-data-table">
                          <DataTable
                            pagination
                            columns={columns}
                            data={data ?? []}
                            progressPending={customVariableLoading}
                          // paginationServer
                          // paginationTotalRows={data?.length}
                          // paginationDefaultPage={currentPage}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          // selectableRows
                          // onSelectedRowsChange={({ selectedRows }) => console.log(selectedRows)}
                          />
                        </div>
                        {window.modulePermissions.M15.add == 1 && (<button type="button" className="btn btn-primary add-btn" data-bs-target="#editPins" srno="1" value="1" onClick={() => setIsVisibleModal(true)}>
                          <Svg name="plus" /> {t('survey.customVariable.add_New_Variable')}
                        </button>)}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={`customvar-modal modal fade edit-pop-modal ${isVisibleModal ? 'show' : ''}`} style={{ display: `${isVisibleModal ? 'block' : 'none'}` }} id="editPins" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body ">
              <div className={"formcontainer"}>
                <form onSubmit={(e) => { if (!canMutate) { e.preventDefault(); return; } handleSubmit(e); }}>
                  <div className={"formvawrapper input-no-margin"}>
                    <div className={"formstyle p-4"} >
                      <Typography
                        type={device === "mobile" ? "h6" : "h5"}
                        colorStep={100}
                        tagName="div"
                        className={"formhead "}
                      >
                        {popupTitle}
                      </Typography>
                      <div className="mt-5">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="">{t('survey.customVariable.label')}<span className="text-primary">*</span></label>
                              <div className="position-relative">
                                <Input
                                  type="text"
                                  view="outlined"
                                  color="default"
                                  className={"formsinput " + style.card__exp}
                                  label=""
                                  fill
                                  placeholder={editMode === 0 ? t('survey.customVariable.label') : values.label}
                                  value={values.label}
                                  name='label'
                                  readOnly={!canMutate}
                                  onChange={canMutate ? handleChange : undefined}
                                  onBlur={handleBlur}
                                //onInput={e => setEditLabel(e.target.value)}
                                />
                                {touched.label && errors.label && <div className="validation-msg">{errors.label}</div>}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="form-group">
                              <label htmlFor="">{t('survey.customVariable.type')}<span className="text-primary">*</span></label>
                              <div className={"position-relative"}>
                                <button
                                  className="btn dropdown-tgl qnaDropdown d-flex align-items-center"
                                  type="button"
                                  id="viewoptions"
                                  data-bs-toggle={canMutate ? "dropdown" : undefined}
                                  aria-haspopup="true"
                                  formaria-expanded="false"
                                  disabled={!canMutate}
                                  onBlur={() => {
                                    setFieldTouched('type', true)
                                  }}
                                >
                                  {values.type ? suTypes[Number(values.type) - 1] : t('survey.customVariable.type')}</button>

                                <div className="dropdown-menu" aria-labelledby="viewoptions"  >
                                  <a className="dropdown-item" onClickCapture={e => canMutate && handleChangeType(1)} >{t('survey.customVariable.number')}</a>
                                  <a className="dropdown-item" onClickCapture={e => canMutate && handleChangeType(2)} >
                                  {t('survey.customVariable.single')}</a>
                                  <a className="dropdown-item" onClickCapture={e => canMutate && handleChangeType(3)} >{t('survey.customVariable.multi')}</a>
                                </div>
                                {touched.type && values.type === '' && <div className="validation-msg">{errors.type}</div>}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="botText mb-4">{t('survey.customVariable.max_charaters')}</div>
                      <div className="input_with_info form-group">
                        <label htmlFor="">{t('survey.customVariable.varName')},
                        <span className="text-primary">*</span></label>
                        <div className={"inputtext position-relative"}>
                          <Input
                            type="text"
                            view="outlined"
                            color="default"
                            label=""
                            placeholder={editMode === 0 ? t('survey.customVariable.varName') : values.varName}
                            value={values.varName}

                            fill
                            name='varName'
                            readOnly={!canMutate}
                            onChange={canMutate ? handleChange : undefined}
                            onBlur={handleBlur}
                            className={"formsinput " + style.card__exp}
                          //onInput={e => setEditName(e.target.value)}
                          />
                          {touched.varName && errors.varName && <div className="validation-msg">{errors.varName}</div>}
                          {uniqueNameError && <div className="validation-msg">{uniqueNameError}</div>}

                          {/* <div className="tooltipInit" onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}><img src={iicon} alt="info" />   {isHovering && (
                            <div className='infobox right'>
                              < Callout
                                type='def'
                                view='outlined'
                                color='primary'
                                title='Unique identifier'
                                icon={< Icon icon='info-sign' iconSize={24} />}
                              >
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum eleifend arcu laoreet elit maximus, eu accumsan tortor suscipit.
                              </Callout >

                            </div>
                          )}</div> */}
                        </div>
                      </div>
                      <div className="botText mb-4">{t('survey.customVariable.max_charaters')}, {t('survey.customVariable.no_spaces')}</div>
                      <div className="form-group">
                        <label htmlFor="">{t('survey.customVariable.description')}<span className="text-primary">*</span></label>
                        <div className={"textareaF position-relative"}>
                          <textarea
                            id=""
                            cols="1"
                            rows="3"
                            value={values.description}
                            name='description'
                            readOnly={!canMutate}
                            onChange={(e) => {
                              if (!canMutate) return;
                              handleChange(e)
                              // setEditDesc(e.target.value)
                            }}
                            onBlur={handleBlur}
                            placeholder={editMode === 0 ? t('survey.customVariable.description') : values.description}>
                          </textarea>
                          {touched.description && errors.description && <div className="validation-msg">{errors.description}</div>}
                        </div>
                      </div>
                      <div className="button-wrap d-flex justify-content-end">
                        <button type="button" className="btn btn-bordered " onClick={cancelEditVariable} data-bs-dismiss="modal">{t('survey.customVariable.cancel')}</button>
                        <button type="submit" className="btn btn-primary ms-3" disabled={!canMutate}>{btnTitle}</button>
                      </div>
                    </div>
                  </div >
                </form>
              </div >
            </div>
          </div>
        </div>
      </div>

      <div className="customvar-modal modal custom-modal fade deleteModal" id="deleteModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                  <Card view="raised" className={"formstyle p-0" + " " + style.card} >

                    <div className="delete-body-wrap delete-language">
                      <div className="heading">
                        <h3>{t('survey.customVariable.del2')}</h3>
                        <p>{t('survey.customVariable.del1')} <strong>{currentlyDeletingVarName ?? ''}</strong> {t('survey.customVariable.permanently')} </p>
                      </div>


                      <div className="button-wrap d-flex justify-content-end">
                        <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => setCurrentlyDeleting(null)}>{t('survey.customVariable.cancel')}</button>
                        {window.modulePermissions.M15.del == 1 && (<button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => deleteVariable(currentlyDeleting)}>{t('survey.customVariable.confirm_delete')}</button>)}
                      </div>
                    </div>
                  </Card>
                </div >

              </div >
            </div>
          </div>
        </div>
      </div>


      <div className={`modal-backdrop fade ${isVisibleModal ? 'show' : ''}`} style={{ display: `${isVisibleModal ? 'block' : 'none'}` }}></div>
    </div>

  )
}
